<template>
    <div>
        <v-row dense class="pl-1 mt-8">
            <v-col cols="3" class="pr-6">
                <select_reporter :selected_reporter="reportedby" field="reportedby" :isClearable="true" @updateData="updateData"/>    
            </v-col>
            <v-col cols="3" class="pr-6">
                <select_slot :selected_slot="incident_slot" field="incident_slot" :isClearable="true" @updateData="updateData"/>    
            </v-col>                    
            <v-col cols="3" class="pr-6">
                <select_gebr :selected_gebr="hokl_gebr" field="hokl_gebr" label="Assigned to" :isClearable="true" @updateData="updateData"/>    
            </v-col>         
            <v-col cols="3">
                <span class="pr-6">
                    <v-spacer/>
                    <v-checkbox v-model="customerHeldLiable" label="Guest is held liable" color="primary" dense hide-details v-on:change="updateCustomerLiable"/>
                </span>						
            </v-col>                                   
        </v-row>

        <v-row dense class="pl-1">        
            <v-col cols="6" class="pr-6">
                <select_incidenttype :selected_incidenttypes="hokl_klct_sel" field="hokl_klct_sel" :isClearable="true" @updateData="updateData"/>    
            </v-col>
            <v-col cols="6" class="pr-6">
                <select_cause :selected_causes="hokl_kloz_sel" field="hokl_kloz_sel" :isClearable="true" @updateData="updateData"/>    
            </v-col>
        </v-row>
    </div>
</template>

<script>

import select_gebr from '@/components/ui/selectors/select_gebr.vue'
import select_reporter from '@/components/huov/ui/select_reporter.vue'
import select_slot from '@/components/huov/hokl/ui/select_slot.vue'
import select_incidenttype from '@/components/huov/hokl/ui/select_incidenttype.vue'
import select_cause from '@/components/huov/hokl/ui/select_cause.vue'

export default {
    props: {
        hokl_gebr:{
            type: String,
            default: ''
        } ,
        reportedby: {
            type: String,
            default: ''
        },
        incident_slot: {
            type: String,
            default: ''
        },        
        hokl_klct_sel:{
            type: Array,
            default: function() { return []; },
        },
        hokl_kloz_sel:{
            type: Array,
            default: function() { return []; },
        },        
        customerLiable:{
            type: Boolean,
            default: false
        },
    },
    components: {
        select_gebr,
        select_reporter,
        select_slot,
        select_incidenttype,
        select_cause
    },

    data() {
        return {      
            customerHeldLiable: this.customerLiable,   
        }
    },
    methods: {
        updateData(data){
            console.log("update data add_hokl", data);
            this.$emit('updateData', data);
            //this[data.field] = data.value;
        },
        updateCustomerLiable(data){
            this.$emit('updateData', {field: 'customerLiable', value: data});
        }
    }
}

</script>